import { scrollToSlide } from './player-navigation';
import { player, slideContainer } from './selectors';
import store from './player-store';

let zoomIndex = 0;
const ZOOM_LEVELS = [1, 1.2, 1.5, 1.75, 2, 2.5, 3, 4];

export const updateZoom = (index) => {
  zoomIndex = index;
  const zoom = ZOOM_LEVELS[index];
  store.zoom = zoom;
  setPlayerZoom();
};

export const resetZoom = () => {
  store.zoom = 0;
  player.removeClass('zoomed');
  slideContainer.css('transform', '');
}

const setPlayerZoom = () => {
  if (store.zoom > 1) {
    player.addClass('zoomed');
    slideContainer.css('transform', `scale(${store.zoom})`);
  } else {
    resetZoom();
  }
}

const zoomIn = () => {
  const newZoomIndex = zoomIndex + 1;
  if (newZoomIndex === ZOOM_LEVELS.length) {
    return;
  }
  updateZoom(newZoomIndex);
};

const zoomOut = () => {
  if (zoomIndex === 0) {
    return;
  }
  const newZoomIndex = zoomIndex - 1;
  updateZoom(newZoomIndex);
};

export const initializeZoom = () => {
  store.zoom = 1;
  $('#zoom-in').on('click', function () {
    zoomIn();
  });

  $('#zoom-out').on('click', function () {
    zoomOut();
  });
};
